import type { ComponentPropsWithRef } from 'react';

import { clsx } from '~/styles/utils';

import type { IconName } from '../Icon/Icon';

import { Icon } from '../Icon/Icon';
import { useNavigationContext } from './Navigation.context';
import { itemStyle } from './Navigation.css';
import { NavigationTooltip } from './NavigationTooltip';

export type NavigationItemProps = ComponentPropsWithRef<'button'> & {
  children: string;
  icon: IconName;
};

export const NavigationButton = ({ children, className, icon, ...delegated }: NavigationItemProps) => {
  const { showLabels } = useNavigationContext();

  return (
    <NavigationTooltip tooltip={children}>
      <button {...delegated} aria-label={children} className={clsx(itemStyle, className)}>
        <Icon name={icon} />

        {showLabels && <span>{children}</span>}
      </button>
    </NavigationTooltip>
  );
};
